import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductSavings extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSavings);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSavings);
  }

  /**
   * Updates the savings message.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSavings = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSavings = event.detail.data.html.querySelector(`product-savings[data-block-id="${this.dataset.blockId}"]`);

    if (!newSavings) return;

    morph(this, newSavings, { childrenOnly: true });
  };
}

if (!customElements.get('product-savings')) {
  customElements.define('product-savings', ProductSavings);
}
